import { RiCloseLine, RiSearchLine } from '@remixicon/react';
import { useState } from 'react';
import { AgButton, AgInput } from 'src/components/ui';

type Props = {
  searchState?: string;
  onSearch: (search: string) => void;
  /**
   * Accessible name for the box. The design carries no visible label, and a
   * `placeholder` is not one — it disappears the moment the user types.
   */
  ariaLabel?: string;
  'data-testid'?: string;
};

export default function ClearableSearch({
  searchState,
  onSearch,
  ariaLabel = 'Search',
  'data-testid': dataTestId,
}: Props) {
  const [search, setSearch] = useState(searchState ?? '');

  return (
    <AgInput
      className="max-w-[400px] grow"
      size="sm"
      placeholder="Search"
      aria-label={ariaLabel}
      value={search}
      onChange={(value) => setSearch(value)}
      onKeyUp={(e) => e.key === 'Enter' && onSearch(search)}
      startContent={<RiSearchLine size={18} />}
      endContent={
        (search || searchState) && (
          <AgButton
            variant="ghost"
            size="icon-xs"
            shape="circle"
            aria-label="Clear search"
            onPress={() => {
              setSearch('');
              onSearch('');
            }}
          >
            <RiCloseLine size={18} />
          </AgButton>
        )
      }
      data-testid={dataTestId}
    />
  );
}
